import React, { Component } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import {
  NitroIcon,
  NitroHeading,
  NitroSingleSelect,
  NitroButton,
  NitroTextField,
  NitroDivider,
  NitroModal,
  NitroParagraph,
  NitroPanel,
} from 'nitro-components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApiActions from '../../../action/ActionFactory';
import * as Endpoints from '../../../api/const';

const ModalContent = styled.div`
  width: 100%;
`;

const ClaimSelect = styled.div`
  min-width: 250px;
`;

const LookupContainer = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  float: left;
  margin-top: 15px;
  height: 35px;
  //line-height: 25px;
  width: 23% !important;
  text-align: right;

  .code {
    font-size: 1.1em;
    font-family: noto-sans-bold;
    //color: #00457c;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height: 45px;
  }
`;
const LookupContainerHeading = styled.div`
  margin-left: auto;
  margin-right: 10px;
  float: left;
  margin-top: 15px;
  height: 35px;
  line-height: 45px;
  width: 22% !important;
  text-align: left;

  .code {
    font-size: 1.1em;
    font-family: noto-sans-bold;
    //color: #00457c;
    //text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height:45px;
    text-align:left;
`;
export const Rowbutton = styled.button`
  top: 25px;
  right: 25px;
  opacity: 0.8;
  transition: opacity 0.3s;
  padding: 0;
  border: 0;
  outline: 0;
  cursor: pointer;
  background: none;
  // display: ${props => (props.readOnly ? 'inline' : 'none')};
`;

const ContainerDivRows = styled.div`
  float: left;
  width: 22% !important;
  margin-left: 0px;
  margin-right: 10px;
  line-height: 60px;
  // text-align: right;
`;

const Container = styled.div``;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 30px;
`;

class UserClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserClaimTypes: [],
      UserClaims: [],
      claimTypeSelected: '',
      userClaimTypeSelected: {},
      NewUserClaimAdded: [],
      SelectedUser: {},
      DistinctUserClaimTypes: [],
      SelectedClaimType: null,
      SelectedClaimValue: null,
      showModal: false,
      deleteAwaited: {},
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.handleAddSelectChange = this.handleAddSelectChange.bind(this);
    this.handleAddSelectedOptions = this.handleAddSelectedOptions.bind(this);
    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.handleRowInputChange = this.handleRowInputChange.bind(this);
    this.setDistinctClaimTypes = this.setDistinctClaimTypes.bind(this);
  }

  componentWillMount() {
    const { user, claims } = this.props;

    this.setState({ SelectedUser: user });
    this.getClaimsByUserId(user.userId);

    if (claims && claims.length > 0) {
      this.setUserClaimTypes(claims);
    }
  }


  getClaimsByUserId(id) {
      const api = Endpoints.BUSINESS_ENTITIES_ADMIN_CLAIMS_BYUSER.replace(
      ':id',
      id
    );
    return axios
      .get(api)
      .then(data => {
        if (data.data.success === true && data.data.data.length > 0) {
          this.setState({
            UserClaims: this.getUserClaims(data.data.data),
          });
        }
      })
      .catch(error => {
        throw error;
      });
  }

  getUserClaims = userClaims => {
    const tmpUserclm = [];
    userClaims.map(e => {
      const objClaim = e;
      objClaim.readOnly = true;
      objClaim.NewValue = e.value;
      tmpUserclm.push(objClaim);
    });

    this.setDistinctClaimTypes(tmpUserclm);
    return tmpUserclm;
  };

  setDistinctClaimTypes(data) {
    const distinct = [];
    this.state.UserClaimTypes.map(e => {
      const flag = data.some(obj => obj.type === e.type);
      if (!flag) {
        distinct.push(e);
      }
    });
    this.setState({ DistinctUserClaimTypes: distinct });
  }
  setClaimType(data) {
    this.state.input = data.value;
  }

  handleAdd = e => {
    const objUserClaim = {};
    objUserClaim.UserId = '';
    objUserClaim.ClaimType = this.state.input;
    objUserClaim.ClaimValue = this.state.ClaimValue;
    this.state.AllUserClaims.push(objUserClaim);
    };

  handleAddSelectChange = event => {
    this.setState({ claimTypeSelected: event.target.value });
    let tmpClaimType = {};
    this.state.UserClaimTypes.map(userClaimType => {
      if (userClaimType.type === event.target.value)
        tmpClaimType = userClaimType;
    });
    this.setState({
      userClaimTypeSelected: tmpClaimType,
    });
  };

  handleAddSelectChangeNitro = event => {
    this.setState({ claimTypeSelected: event.value });
    let tmpClaimType = {};
    this.state.UserClaimTypes.map(userClaimType => {
      if (userClaimType.type === event.value) tmpClaimType = userClaimType;
    });
    this.setState({
      userClaimTypeSelected: tmpClaimType,
      SelectedClaimType: event.value,
    });
  };

  onAddButtonClick = () => {
    const tmpUserClms = this.state.UserClaims;
    this.state.NewUserClaimAdded.forEach(e => {
      const objclaim = e;
      objclaim.readOnly = true;
      objclaim.NewValue = e.value;
      tmpUserClms.push(objclaim);
    });

    this.setState({ UserClaims: tmpUserClms });

    this.setDistinctClaimTypes(tmpUserClms);
    this.setState({
      NewUserClaimAdded: [],
      userClaimTypeSelected: {},
      SelectedClaimType: '',
      SelectedClaimValue: '',
    });
    event.target.value = '';
    this.setState({
      UserClaims: tmpUserClms,
    });
  };

  onEditButtonClick = data => {
    const readOnlyFlag = data.readOnly;
    const flag = !data.readOnly;

    const tmpClaims = [];
    this.state.UserClaims.map(e => {
      if (e.type === data.type && e.value === data.value) {
        const objClaims = e;
        objClaims.readOnly = flag;
        tmpClaims.push(objClaims);
      } else {
        tmpClaims.push(e);
      }
    });
    this.setState({ UserClaims: tmpClaims });

    // if (readOnlyFlag !== true) {
    //   this.props.onChangeUserClaims(tmpClaims);
    // }
  };

  onDeleteButtonClick = data => {
    this.setState({ deleteAwaited: data });
    this.setState({ showModal: true });
  };

  setUserClaimTypes = data => {
    this.setState({ UserClaimTypes: data });
    this.setState({ DistinctUserClaimTypes: data });
  };

  deleteReject = () => {
    this.setState({ deleteAwaited: {} });
    this.setState({ showModal: false });
  };

  deleteUserClaim = () => {
    const tmpUserClms = [];
    const data = this.state.deleteAwaited;
    this.state.UserClaims.map(e => {
      if (!(e.type === data.type && e.value === data.value))
        tmpUserClms.push(e);
    });
    this.setState({
      UserClaims: tmpUserClms,
    });
    this.setDistinctClaimTypes(tmpUserClms);
    this.setState({ showModal: false });
    this.setState({ deleteAwaited: {} });
  };

  handleRowInputChange = (data, event) => {
    const objValue = {
      type: data.type,
      value: data.value,
    };
    const tmpuserClmsInput = [];
    this.state.UserClaims.map(e => {
      if (e.type === objValue.type && e.value === objValue.value) {
        const objTmp = e;
        objTmp.NewValue = event.value;
        tmpuserClmsInput.push(objTmp);
      } else {
        tmpuserClmsInput.push(e);
      }
    });
    this.setState({ UserClaims: tmpuserClmsInput });
  };

  handleRowInputChangeText = (data, event) => {
    const objValue = {
      type: data.type,
      value: data.value,
    };
    const tmpuserClaimstext = [];
    this.state.UserClaims.map(e => {
      if (e.type === objValue.type && e.value === objValue.value) {
        const objTmp = e;
        objTmp.NewValue = event.target.value;
        tmpuserClaimstext.push(objTmp);
      } else {
        tmpuserClaimstext.push(e);
      }
    });
    this.setState({ UserClaims: tmpuserClaimstext });
  };

  handleAddSelectedOptions = event => {
    const tmpUserClaim = [
      {
        type: event.target.getAttribute('data-id'),
        value: event.target.value,
        description: event.target.getAttribute('data-des'),
      },
    ];
    this.setState({
      NewUserClaimAdded: tmpUserClaim,
    });
  };

  handleAddSelectedOptionsNitro = (data, event) => {
    const tmpUserClaim = [
      {
        type: data.type,
        value: event.value,
        description: data.description,
      },
    ];
    this.setState({
      NewUserClaimAdded: tmpUserClaim,
      SelectedClaimValue: event.value,
    });
  };
  onEditClick = data => {
    const tmpClaims = [];
    this.state.UserClaims.map(e => {
      if (e.type === data.type && e.value === data.value) {
        const objClaims = e;
        objClaims.readOnly = false;
        tmpClaims.push(objClaims);
      } else {
        tmpClaims.push(e);
      }
    });
    this.setState({ UserClaims: tmpClaims });
  };
  onSaveClick = data => {
    const tmpClaims = [];
    this.state.UserClaims.map(e => {
      if (e.type === data.type && e.value === data.value) {
        const objClaims = e;
        objClaims.value = e.NewValue;
        objClaims.readOnly = true;
        tmpClaims.push(objClaims);
      } else {
        tmpClaims.push(e);
      }
    });
    this.setState({ UserClaims: tmpClaims });
  };

  render() {
    const getSelectOptions = options => {
      const opt = [];
      if (options !== undefined) {
        options.forEach(element => {
          opt.push({ value: element, label: element });
        });
      }
      return opt;
    };

    const getEditableRow = (rowData, UserClaimTypes, idx) => {
      if (
        UserClaimTypes.some(e => e.type === rowData.type && e.values !== null)
      ) {
        let values = [];
        UserClaimTypes.map(ele => {
          if (ele.type === rowData.type) {
            values = ele.values;
          }
        });
        return (
          <div key={`editable_row_${idx}`}>
            <LookupContainerHeading>
              <span className="code"> {rowData.description}</span>{' '}
            </LookupContainerHeading>
            <LookupContainer>
              {rowData.readOnly === true ? (
                <span className="code">{rowData.value}</span>
              ) : (
                <NitroSingleSelect
                  alignLeft
                  mandatory
                  bold
                  data-id={rowData.type}
                  data-value={rowData.NewValue}
                  options={getSelectOptions(values)}
                  value={rowData.NewValue}
                  action={e => this.handleRowInputChange(rowData, e)}
                />
              )}
            </LookupContainer>
            <LookupContainer>
              {' '}
              {rowData.readOnly === true ? (
                <Rowbutton onClick={() => this.onEditClick(rowData)}>
                  <NitroIcon
                    name="edit"
                    variant="secondary"
                    size={14}
                    right={8}
                  />
                </Rowbutton>
              ) : (
                <Rowbutton onClick={() => this.onSaveClick(rowData)}>
                  <NitroIcon
                    name="save"
                    variant="secondary"
                    size={14}
                    right={8}
                  />
                </Rowbutton>
              )}
            </LookupContainer>{' '}
            <LookupContainer>
              <Rowbutton
                data-key={rowData.type}
                data-id={rowData.value}
                onClick={() => this.onDeleteButtonClick(rowData)}>
                {' '}
                <NitroIcon
                  name="delete"
                  variant="secondary"
                  size={14}
                  right={8}
                />
              </Rowbutton>{' '}
            </LookupContainer>
            <ContainerDivRows />
            <Container>
              <NitroDivider />
            </Container>
          </div>
        );
      } else if (
        UserClaimTypes.some(e => e.type === rowData.type && e.values === null)
      ) {
        return (
          <div>
            <LookupContainerHeading className="code">
              <span className="code">{rowData.description}</span>
            </LookupContainerHeading>
            <LookupContainer>
              {rowData.readOnly == true ? (
                <span className="code">{rowData.value}</span>
              ) : (
                <NitroTextField
                  value={rowData.NewValue}
                  onChange={e => this.handleRowInputChangeText(rowData, e)}
                  data-id={rowData.type}
                  data-value={rowData.NewValue}
                />
              )}
            </LookupContainer>
            <LookupContainer>
              {' '}
              {rowData.readOnly === true ? (
                <Rowbutton onClick={() => this.onEditClick(rowData)}>
                  <NitroIcon
                    name="edit"
                    variant="secondary"
                    size={14}
                    right={8}
                  />
                </Rowbutton>
              ) : (
                <Rowbutton onClick={() => this.onSaveClick(rowData)}>
                  <NitroIcon
                    name="save"
                    variant="secondary"
                    size={14}
                    right={8}
                  />
                </Rowbutton>
              )}{' '}
            </LookupContainer>
            <LookupContainer>
              <Rowbutton
                data-key={rowData.type}
                data-id={rowData.value}
                onClick={() => this.onDeleteButtonClick(rowData)}>
                {' '}
                <NitroIcon
                  name="delete"
                  variant="secondary"
                  size={14}
                  right={8}
                />
              </Rowbutton>{' '}
            </LookupContainer>{' '}
            <ContainerDivRows />
            <Container>
              <NitroDivider />
            </Container>
          </div>
        );
      }
    };

    const getTypeField = type => {
      // if (type.values === undefined) {
      //   return 'Please select type.';
      // }
      if (type !== null && type.values === null) {
        return (
          <NitroTextField
            placeholder="User claim value"
            data-id={type.type}
            data-des={type.description}
            onChange={this.handleAddSelectedOptions}
          />
        );
      }
      return (
        <ClaimSelect>
          <NitroSingleSelect
            alignLeft
            mandatory
            placeholder="Select Claim Value"
            bold
            options={getSelectOptions(type.values)}
            action={e => this.handleAddSelectedOptionsNitro(type, e)}
            value={this.state.SelectedClaimValue}
            containerMaxHeight="150px"
          />
        </ClaimSelect>
      );
    };

    const getClaimTypeOptions = UserClaimTypes => {
      const options = [];
      UserClaimTypes.map(element => {
        options.push({ value: element.type, label: element.description });
      });
      return options;
    };

    const divAddClaim = UserClaimTypes => {
      const divResult = UserClaimTypes.map(element => (
        <option value={element.type}>{element.description}</option>
      ));
      return (
        <div>
          <LookupContainerHeading>
            <NitroHeading
              size="2"
              label="Add new user claim"
              variant="secondary"
            />
          </LookupContainerHeading>
          <LookupContainer>
            <NitroSingleSelect
              alignLeft
              mandatory
              placeholder="Select Claim Type"
              bold
              options={getClaimTypeOptions(UserClaimTypes)}
              action={this.handleAddSelectChangeNitro}
              value={this.state.SelectedClaimType}
            />
            {/* <SelectInput onChange={this.handleAddSelectChange}>
              <option value="">Select type</option>
              {divResult}
            </SelectInput> */}
          </LookupContainer>

          <LookupContainer>
            {getTypeField(
              this.state.userClaimTypeSelected === undefined
                ? ''
                : this.state.userClaimTypeSelected
            )}
          </LookupContainer>
          <LookupContainer>
            <NitroButton
              label="Add"
              size="small"
              variant="primary"
              action={() => this.onAddButtonClick()}
            />
          </LookupContainer>
        </div>
      );
    };

    const divTable = UserClaimTypes => {
      let divTableResult = <Container>No claims for the user yet!!</Container>;
      if (this.state.UserClaims !== undefined) {
        divTableResult = this.state.UserClaims.map((e, idx) =>
          getEditableRow(e, UserClaimTypes, idx)
        );
      }
      return divTableResult;
    };

    if (!this.props.claims || this.props.claims.length <= 0) return null;

    return (
      <NitroPanel>
        <section>
          <div>
            <NitroHeading label="User Claims" size="1" variant="secondary" />
          </div>
          <Container>
            {divAddClaim(this.state.DistinctUserClaimTypes)}
          </Container>
          <Container>
            <NitroDivider />
          </Container>
          <Container>{divTable(this.state.UserClaimTypes)}</Container>
        </section>

        <NitroModal
          title="Confirm delete user claim"
          action={this.deleteUserClaim}
          actionLabel="Continue"
          cancelAction={this.deleteReject}
          cancelLabel="Cancel"
          isOpen={this.state.showModal}
          close={this.deleteReject}
          messageFlexDirection="row">
          <ModalContent>
            <NitroParagraph align="center">
              Do you want to delete user claim -{' '}
              {this.state.deleteAwaited.description} -({
                this.state.deleteAwaited.value
              }) ?
            </NitroParagraph>

            <NitroParagraph align="center" />
          </ModalContent>
        </NitroModal>
      </NitroPanel>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  apiActions: bindActionCreators(ApiActions, dispatch),
});

export default connect(
  null,
  mapDispatchToProps,
  null,
  { withRef: true }
)(UserClaims);



// WEBPACK FOOTER //
// ./src/features/admin/components/UserClaims.js